import React from 'react';
import { readingActionButtonClassName } from './fitnessProfileReadingStyles';

export function LogReadingEditButton({ onClick, ariaLabel, title }) {
	return (
		<button
			type="button"
			onClick={onClick}
			className={readingActionButtonClassName}
			aria-label={ariaLabel}
			title={title}
		>
			<i className="fa-solid fa-pencil text-sm" aria-hidden="true" />
		</button>
	);
}

export function LogReadingAddButton({ onClick, ariaLabel, title }) {
	return (
		<button
			type="button"
			onClick={onClick}
			className={`${readingActionButtonClassName} text-lg font-medium leading-none`}
			aria-label={ariaLabel}
			title={title}
		>
			+
		</button>
	);
}

export default function FitnessProfileReadingActions({
	onEdit,
	onAdd,
	editAriaLabel,
	editTitle,
	addAriaLabel,
	addTitle
}) {
	return (
		<div className="flex items-center gap-1.5 shrink-0">
			{onEdit && (
				<LogReadingEditButton onClick={onEdit} ariaLabel={editAriaLabel} title={editTitle} />
			)}
			<LogReadingAddButton onClick={onAdd} ariaLabel={addAriaLabel} title={addTitle} />
		</div>
	);
}
